// src/utils/tool.js
import router from '@/router'

/**
 * 公共路由跳转方法
 * @param {string|object} config - 配置对象或路径字符串
 * @param {boolean} isNewTab - 是否在新标签页打开（默认 true）
 * @returns {void}
 */
export function toPage(config, isNewTab = true) {
	if (!config) {
		console.error('路由跳转失败：config不能为空');
		return;
	}

	try {
		let finalPath = '';

		if (typeof config === 'string') {
			// 如果是字符串，直接作为路径
			finalPath = config.startsWith('/') ? config : `/${config}`;
		} else if (typeof config === 'object') {
			// 如果是对象，支持 path、name 两种方式
			if (config.name) {
				// 使用路由名称跳转
				const routeData = router.resolve({
					name: config.name,
					params: config.params || {},
					query: config.query || {}
				});
				if (isNewTab) {
					window.open(routeData.href, '_blank');
				} else {
					router.push({
						name: config.name,
						params: config.params || {},
						query: config.query || {}
					});
				}
				return;
			}

			// 使用路径跳转
			const {
				path,
				id,
				params = {},
				query = {}
			} = config;
			finalPath = id ? `/${path}/${id}` : `/${path}`;

			// 添加查询参数
			if (Object.keys(query).length > 0) {
				const queryString = new URLSearchParams(query).toString();
				finalPath += `?${queryString}`;
			}
		} else {
			console.error('路由跳转失败：config类型错误，应为字符串或对象');
			return;
		}

		const routeData = router.resolve({
			path: finalPath
		});

		if (isNewTab) {
			window.open(routeData.href, '_blank');
		} else {
			router.push({
				path: finalPath
			});
		}
	} catch (error) {
		console.error('路由跳转异常：', error);
	}
}

// 挂载到全局
export function setupGlobalToPage(app) {
	app.config.globalProperties.$toPage = toPage;
}

/*
 * 公共路由跳转方法
 * @param {string} name 路由名称
 * @param {object} query 查询参数
 * @param {boolean} isNewTab 是否新标签页打开
 */
export function navigateTo(name, query = {}, isNewTab = true) {
	if (!name || typeof name !== 'string') {
		console.error('路由跳转失败：name必须为非空字符串')
		return
	}

	try {
		const routeData = router.resolve({
			name,
			query
		})
		if (isNewTab) {
			window.open(routeData.href, '_blank')
		} else {
			router.push({
				name,
				query
			})
		}
	} catch (error) {
		console.error('路由跳转异常：', error)
	}
}